import React from 'react';
import { useFieldArray, Controller } from 'react-hook-form';
import { AddIcon, DeleteIcon } from './icons';

export const BridgeInterfaces = ({ control, bridgeIndex, interfaces, validateUniqueness, errors, getValues, trigger }) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: `vendoInstances.${bridgeIndex}.interfaces`
    });

    return (
        <div className="space-y-2">
            {fields.map((item, ifaceIndex) => (
                <div key={item.id} className="flex items-center gap-2">
                    <div className="flex-grow">
                        <Controller
                            name={`vendoInstances.${bridgeIndex}.interfaces.${ifaceIndex}.value`}
                            control={control}
                            rules={{
                                required: 'Required',
                                validate: value => validateUniqueness(value, `${bridgeIndex}-${ifaceIndex}`)
                            }}
                            render={({ field }) => (
                                <select 
                                    {...field} 
                                    className="input-class w-full text-sm"
                                    onChange={e => {
                                        field.onChange(e);
                                        // Trigger validation for all other interface fields
                                        if (trigger) {
                                            trigger("vendoInstances");
                                            trigger("pppoeInterfaceAssignment");
                                        }
                                    }}
                                >
                                    <option value="">-- Assign Interface --</option>
                                    {interfaces.map(iface => <option key={iface} value={iface}>{iface}</option>)}
                                </select>
                            )}
                        />
                         {errors.vendoInstances?.[bridgeIndex]?.interfaces?.[ifaceIndex]?.value && <p className="text-red-500 text-xs mt-1">{errors.vendoInstances[bridgeIndex].interfaces[ifaceIndex].value.message}</p>}
                    </div>
                    <button type="button" onClick={() => remove(ifaceIndex)} className="p-2 text-red-500 hover:text-red-700">
                        <DeleteIcon />
                    </button>
                </div>
            ))}
            <button
                type="button"
                onClick={() => append({ value: '' })}
                className="btn-secondary text-xs px-2 py-1 flex items-center gap-1"
            >
                <AddIcon /> Add Interface
            </button>
        </div>
    );
};